export default __webpack_public_path__ + "app/images/banner_homepage_linshare.png";